const PREVIEW_CACHE_LIMIT = 1000;
const previewCacheByLength = new Map();

/**
 * Cleans HTML content for preview display by removing tags and adding proper spacing
 * @param {string} htmlContent - The HTML content to clean
 * @param {number} maxLength - Maximum length for the preview (default: 150)
 * @returns {string} - Cleaned text content with proper spacing
 */
export const cleanHtmlForPreview = (htmlContent, maxLength = 150) => {
  if (!htmlContent) return '';

  // Article lists call this for every card on every render, with full article HTML.
  let previewCache = previewCacheByLength.get(maxLength);
  if (!previewCache) {
    previewCache = new Map();
    previewCacheByLength.set(maxLength, previewCache);
  }
  const cached = previewCache.get(htmlContent);
  if (cached !== undefined) return cached;
  
  const cleanContent = htmlContent
    .replace(/<h[1-6][^>]*>/gi, ' ') // Replace headers with space
    .replace(/<\/h[1-6]>/gi, ' ') // Replace closing headers with space
    .replace(/<p[^>]*>/gi, ' ') // Replace paragraph tags with space
    .replace(/<\/p>/gi, ' ') // Replace closing paragraph tags with space
    .replace(/<li[^>]*>/gi, ' • ') // Replace list items with bullet
    .replace(/<\/li>/gi, ' ') // Replace closing list items with space
    .replace(/<ul[^>]*>/gi, ' ') // Replace unordered lists with space
    .replace(/<\/ul>/gi, ' ') // Replace closing unordered lists with space
    .replace(/<ol[^>]*>/gi, ' ') // Replace ordered lists with space
    .replace(/<\/ol>/gi, ' ') // Replace closing ordered lists with space
    .replace(/<br\s*\/?>/gi, ' ') // Replace line breaks with space
    .replace(/<[^>]*>/g, '') // Remove all other HTML tags
    // Decode HTML entities
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&#x([0-9A-Fa-f]+);/g, (match, hex) => String.fromCharCode(parseInt(hex, 16)))
    .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(parseInt(dec, 10)))
    .replace(/\s+/g, ' ') // Replace multiple spaces with single space
    .trim();
  
  const preview = cleanContent.length > maxLength 
    ? cleanContent.substring(0, maxLength) + '...' 
    : cleanContent;
  if (previewCache.size >= PREVIEW_CACHE_LIMIT) previewCache.clear();
  previewCache.set(htmlContent, preview);
  return preview;
}; 